import { render } from "./CreateTable.vue?vue&type=template&id=512714ba"
import script from "./CreateTable.vue?vue&type=script&lang=js"
export * from "./CreateTable.vue?vue&type=script&lang=js"

import "./CreateTable.vue?vue&type=style&index=0&id=512714ba&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__